export default __webpack_public_path__ + "static/media/game_over_background.21509171.png";